// Campo de data vindo da API pode ser nulo ou vir fora do formato esperado (cliente sem
// data de nascimento cadastrada, por exemplo). Sem a guarda, o split estoura e derruba a
// TELA INTEIRA no ErrorBoundary, deixando o cliente na tela branca. Aqui devolvemos string
// vazia: o campo aparece em branco e o resto da pagina continua funcionando.
export const formatoData = (data?: string | null) => {
  if (!data) return '';

  const [date] = data.split('T');
  if (!date) return '';

  const [year, month, day] = date.split('-');
  if (!year || !month || !day) return '';

  return day + '/' + month + '/' + year;
};

const meses = [
  '-',
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ',
];

// Mesma protecao do formatoData: nulo ou formato inesperado nao pode derrubar a tela.
export const formatoMesAno = (data?: string | null) => {
  if (!data) return '';

  const [date] = data.split(' ');
  if (!date) return '';

  const [, month, year] = date.split('/');
  if (!month || !year) return '';

  const mes = meses[parseInt(month)];
  if (!mes) return '';

  return mes + '/' + year;
};
